var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusDottedBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add_Assignee",
    "data-name": "Add Assignee",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M351.1,270.336a17.5,17.5,0,1,1-17.5-17.5,17.5,17.5,0,0,1,17.5,17.5",
    transform: "translate(-316.102 -252.836)",
    fill: "none",
    stroke: "#475757",
    strokeWidth: 1,
    strokeDasharray: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M409.624,331.993H402.88v-6.637a1.629,1.629,0,0,0-3.256,0v6.637H392.88a1.566,1.566,0,1,0,0,3.129h6.745v6.33a1.629,1.629,0,0,0,3.256,0v-6.33h6.744a1.566,1.566,0,1,0,0-3.129",
    transform: "translate(-383.752 -315.904)",
    fill: "#00246a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusDottedBlueIcon);
export default __webpack_public_path__ + "static/media/plus-dotted-blue-icon.46406f5dd934edeed6e8a915ef8558b9.svg";
export { ForwardRef as ReactComponent };